import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import { FaCaretRight, FaCaretLeft } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';
import { Container, Comunicacao, Marketing, Servicos } from './styles';
import Logo from '~/assets/logo_home.png';
//import Call from '~/assets/call.png';
//import whats from '~/assets/whats.png';
import banner_marketing from '~/assets/banner_marketing.png';
import servicos_1 from '~/assets/servicos_1.png';
import servicos_2 from '~/assets/servicos_2.png';
import servicos_3 from '~/assets/servicos_3.png';
import seta from '~/assets/seta.png';
import Univar from '~/assets/univar_interno.png';
import novartis from '~/assets/novartis_interno.png';
import aon from '~/assets/aon_interno.png';
import olin from '~/assets/olin_interno.png';
import friozem from '~/assets/friozem_interno.png';
import emerson from '~/assets/emerson_interno-new.png';
import gemelo from '~/assets/gemelo_interno.png';
import wedigitek from '~/assets/wedigitek_interno.png';

function Home() {
  const [lgShow, setLgShow] = useState(false);
  const [initialBottom, setInitialBottom] = useState(0);
  const [fixed, setFixed] = useState(true);
  const [ImgInsideModal, setImgInsideModal] = useState();
  function abrirModal(img) {
    setImgInsideModal(img);
    setLgShow(true);
  }

  const [elements, setElements] = useState(
    document.querySelectorAll('.bg-comunicacao')
  );
  const [elements2, setElements2] = useState(
    document.querySelectorAll('.servicos-saiba')
  );
  const location = useLocation();

  window.onscroll = () => {
    let bottom = 62;
    if (window.innerWidth < 1200) {
      bottom = 25;
    }
    if (
      window.scrollY >=
      Math.round(initialBottom) - window.innerHeight + bottom
    ) {
      setFixed(false);
    } else {
      setFixed(true);
    }
  };
  useEffect(() => {
    const btnEnviar = document
      .querySelector('.btn-enviar')
      .getBoundingClientRect().bottom;
    setInitialBottom(btnEnviar);
    if (elements.length > 0) {
      elements.forEach(element => {
        element.onclick = e => {
          const Elemento = e.target.closest('.bg-comunicacao');
          const Elemento2 = Elemento.querySelector('.bg-comunicacao-2');
          Elemento2.classList.toggle('d-none');
          Elemento.classList.toggle('bg-generico');
        };
      });
    } else {
      setElements(document.querySelectorAll('.bg-comunicacao'));
    }
  }, [elements, location]);
  useEffect(() => {
    if (elements2.length > 0) {
      elements2.forEach(element => {
        element.onclick = e => {
          const Elemento = e.target;
          const Elemento2 = e.target.previousElementSibling;
          Elemento2.classList.toggle('d-none');
          if (Elemento.innerText === 'Ler mais') {
            Elemento.innerText = 'Ver Menos';
          } else {
            Elemento.innerText = 'Ler mais';
          }
        };
      });
    } else {
      setElements2(document.querySelectorAll('.servicos-saiba'));
    }
  }, [elements2, location]);
  return (
    <>
      <Container>
        <div className="banner">
          <div className="container">
            <div className="row flex-row-reverse">
              <div className="col-md-12 text-center pb-md-4 pb-0">
                <h2>MARKETING</h2>
              </div>
              <div className="col-md-6 text-center">
                <img src={Logo} className="py-3" alt="AMZ|b2b" />
                <h1>
                  <span>Especializada </span>
                  <span>em&nbsp;comunicação </span>
                  <span> corporativa</span>
                </h1>
                <p className="pb-5 pb-md-0">
                  Fundada em 2008 a amz b2b é referência nacional no marketing
                  b2b que atende grandes líderes globais para toda a América
                  Latina com foco em comunicação empresarial.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="container hg-180">
          <div className="row">
            <div className="col-12">
              <a
                href="https://api.whatsapp.com/send?phone=+551198224.2385"
                title="whatsapp"
                onClick={() => window.wpp_conversion()}
              >
                <img
                  src={Call}
                  className={`mt-negativa img-agende ${
                    fixed ? 'fixed' : 'absolute'
                  }`}
                  alt="clique aqui e agende um call"
                />
              </a>
            </div>
          </div>
        </div> */}
      </Container>
      <Comunicacao className="py-md-5 pt-5">
        <div className="container overflow-sm">
          <div className="row w-1440">
            <div className="col-md-12 col-4">
              <div className="row">
                <div className="col-4 bg-1">
                  <div
                    className="bg-comunicacao d-flex align-items-center"
                    // onClick={() => abrirModal(Univar)}
                  >
                    <div className="col-12">
                      <h3>Univar Solutions,</h3>
                      <p>maior distribuidora de produtos químicos do mundo</p>
                    </div>
                    <div className="bg-comunicacao-2 d-none">
                      <img src={Univar} alt="univar" />
                    </div>
                  </div>
                </div>
                <div className="col-4 bg-2">
                  <div
                    className="bg-comunicacao d-flex align-items-center"
                    // onClick={() => abrirModal(novartis)}
                  >
                    <div className="col-12">
                      <h3>Novartis,</h3>
                      <p>terceira maior indústria farmacêutica do mundo</p>
                    </div>
                    <div className="bg-comunicacao-2 d-none">
                      <img src={novartis} alt="novartis" />
                    </div>
                  </div>
                </div>
                <div className="col-4 bg-3">
                  <div
                    className="bg-comunicacao d-flex align-items-center"
                    // onClick={() => abrirModal(aon)}
                  >
                    <div className="col-12">
                      <h3>Aon,</h3>
                      <p>maior corretora de seguros do mundo</p>
                    </div>
                    <div className="bg-comunicacao-2 d-none">
                      <img src={aon} alt="aon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 2 Linha */}
            <div className="col-md-12 col-4">
              <div className="row">
                <div className="col-4 my-md-4 bg-4">
                  <div
                    className="bg-comunicacao d-flex align-items-center"
                    // onClick={() => abrirModal(olin)}
                  >
                    <div className="col-12">
                      <h3>Olin,</h3>
                      <p>maior produtora de resina epóxi do mundo</p>
                    </div>
                    <div className="bg-comunicacao-2 d-none">
                      <img src={olin} alt="olin" />
                    </div>
                  </div>
                </div>
                <div className="col-4 my-md-4 bg-5">
                  <div className="h-100 text-center d-flex align-items-center">
                    <div className="col-12">
                      <p className="color-blue font-1">
                        Referência em
                      </p>
                      <h4 className="color-blue mb-0">comunicação</h4>
                      <p className="color-blue font-2">corporativa atendendo</p>
                      <h4 className="color-orange mb-0 font-3">
                        líderes globais
                      </h4>
                      <p className="color-blue font-1">do segmento b2b</p>
                    </div>
                  </div>
                </div>
                <div className="col-4 my-md-4 bg-6">
                  <div
                    className="bg-comunicacao d-flex align-items-center"
                    // onClick={() => abrirModal(friozem)}
                  >
                    <div className="col-12">
                      <h3>Friozem,</h3>
                      <p>
                        entre as 20 maiores logísticas refrigeradas do mundo
                      </p>
                    </div>
                    <div className="bg-comunicacao-2 d-none">
                      <img src={friozem} alt="friozem" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 3 Linha */}
            <div className="col-md-12 col-4">
              <div className="row">
                <div className="col-4 bg-7">
                  <div
                    className="bg-comunicacao d-flex align-items-center"
                    // onClick={() => abrirModal(emerson)}
                  >
                    <div className="col-12">
                      <h3>Emerson,</h3>
                      <p>
                        especializada em soluções: comerciais, residenciais e de
                        automação.
                      </p>
                    </div>
                    <div className="bg-comunicacao-2 d-none">
                      <img src={emerson} alt="emerson" />
                    </div>
                  </div>
                </div>
                <div className="col-4 bg-8">
                  <div
                    className="bg-comunicacao d-flex align-items-center"
                    // onClick={() => abrirModal(gemelo)}
                  >
                    <div className="col-12">
                      <h3>Gemelo,</h3>
                      <p>
                        a maior fábrica de Data Center Pré-Fabricado Outdoor da
                        América Latina
                      </p>
                    </div>
                    <div className="bg-comunicacao-2 d-none">
                      <img src={gemelo} alt="gemelo" />
                    </div>
                  </div>
                </div>
                <div className="col-4 bg-9">
                  <div
                    className="bg-comunicacao d-flex align-items-center"
                    // onClick={() => abrirModal(wedigitek)}
                  >
                    <div className="col-12">
                      <h3>We:digitek,</h3>
                      <p>soluções em tecnologia para redes de restaurantes</p>
                    </div>
                    <div className="bg-comunicacao-2 d-none">
                      <img src={wedigitek} alt="wedigitek" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container pt-4 visible-mobile">
          <div className="row">
            <div className="col-12">
              <img src={seta} alt="seta horizontal" />
            </div>
          </div>
        </div>
      </Comunicacao>
      <Marketing>
        <div className="container my-4" id="sobre">
          <div className="row">
            <div className="col-12 text-center">
              <span>Desde 2008</span>
              <h2>
                ATUANDO&nbsp;EM
                <br /> MARKETING&nbsp;B2B
              </h2>
            </div>
            <div className="col-md-6 order-2 order-md-1">
              <div className="row h-100 align-items-center flex-row-reverse">
                <div className="col-md-9 text-center text-md-left">
                  <p>
                    Nos especializamos em um segmento que muitas vezes não
                    aparece, mas que move a economia global e promove a
                    convergência entre matérias-primas, empresas, produtos e
                    pessoas.
                  </p>
                  <p className="paragrafo-2">
                    O mundo pode até não conhecer, mas o mercado conhece muito
                    bem e um planejamento de marketing e comunicação empresarial
                    é essencial para promover a boa gestão do negócio, o
                    relacionamento com clientes e a constante busca por
                    crescimento.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 order-1 order-md-2">
              <img src={banner_marketing} alt="ATUANDO EM MARKETING B2B" />
            </div>
          </div>
        </div>
      </Marketing>
      <Servicos>
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center mb-4">
              <h3>NOSSOS SERVIÇOS</h3>
            </div>
            <div className="col-12 overflow">
              <div className="row w-1440">
                <div className="col-4 text-center">
                  <div className="row">
                    <div className="col-4 col-md-12">
                      <img src={servicos_1} alt="Comunicação Integrada" />
                    </div>
                    <div className="col-8 col-md-12">
                      <h2 className="my-4 text-uppercase">
                        Estratégia de Comunicação e Marketing
                        <span className="visible-mobile">
                          <br />
                          &nbsp;
                        </span>
                      </h2>
                    </div>
                  </div>
                  <p className="text-left mb-2">
                    A <strong> comunicação corporativa </strong>precisa ser
                    ativa, presente, impactante e falar sempre a mesma língua.
                    <br />
                  </p>
                  <p className="d-none textos-saiba text-left">
                    Por isso, atuamos nas estratégias de Marketing, entendendo
                    problemas e objetivos, para então conectar integralmente
                    todo ciclo de <strong>comunicação 360°</strong> da marca,
                    com{' '}
                    <strong>
                      {' '}
                      ações digitais e presenciais que conversam com todos os
                      stakeholders.
                    </strong>
                  </p>
                  <p className="servicos-saiba my-4">Ler mais</p>
                  <AnchorLink
                    href="#contato"
                    offset={117}
                    title="tenho interesse"
                    className="tenho-interesse"
                  >
                    <FaCaretLeft className="mr-2" />
                    TENHO INTERESSE
                    <FaCaretRight className="ml-2" />
                  </AnchorLink>
                </div>
                <div className="col-4 text-center">
                  <div className="row">
                    <div className="col-4 col-md-12">
                      <img
                        src={servicos_2}
                        alt="Gestão de Branding e Conteúdo"
                      />
                    </div>
                    <div className="col-8 col-md-12">
                      <h2 className="my-4">GESTÃO DE BRANDING E CONTEÚDO</h2>
                    </div>
                  </div>
                  <p className="text-left mb-2">
                    A percepção da sua marca está diretamente relacionada com o
                    seu posicionamento.
                  </p>
                  <p className="textos-saiba text-left d-none">
                    As qualidades e os diferenciais da empresa precisam ser
                    percebidas na comunicação.
                    <br />
                    <br />
                    Atuamos em todos os processos da nacionalização de
                    comunicação de acordo com recomendação globa, gestão de
                    branding, criação ou revitalização dos valores corporativos,
                    brandbooks, redes sociais e Blog.
                  </p>
                  <p className="servicos-saiba my-4">Ler mais</p>
                  <AnchorLink
                    href="#contato"
                    offset={117}
                    title="tenho interesse"
                    className="tenho-interesse"
                  >
                    <FaCaretLeft className="mr-2" />
                    TENHO INTERESSE
                    <FaCaretRight className="ml-2" />
                  </AnchorLink>
                </div>
                <div className="col-4 text-center">
                  <div className="row">
                    <div className="col-4 col-md-12">
                      <img src={servicos_3} alt="Geração de Leads" />
                    </div>
                    <div className="col-8 col-md-12">
                      <h2 className="my-4">
                        GERAÇÃO
                        <br /> DE&nbsp;LEADS
                        <span className="visible-mobile">
                          <br />
                          &nbsp;
                        </span>
                      </h2>
                    </div>
                  </div>
                  <p className="text-left mb-2">
                    A busca por leads qualificados é o que gera as oportunidades
                    mais assertivas.
                  </p>
                  <p className="textos-saiba text-left d-none">
                    Contar com uma boa base de Leads qualificados para o mercado
                    b2b é um dos principais desafios para o todo departamento de
                    marketing.
                    <br />
                    <br />
                    Estamos preparados paracriar seu funil de vendas através de
                    ferramentas de busca Google e similares e atrair um público
                    de interesse por meio de campanhas inbound marketing.
                  </p>
                  <p className="servicos-saiba my-4">Ler mais</p>
                  <AnchorLink
                    href="#contato"
                    offset={117}
                    title="tenho interesse"
                    className="tenho-interesse"
                  >
                    <FaCaretLeft className="mr-2" />
                    TENHO INTERESSE
                    <FaCaretRight className="ml-2" />
                  </AnchorLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container pb-4 visible-mobile">
          <div className="row">
            <div className="col-12">
              <img src={seta} alt="seta horizontal" />
            </div>
          </div>
        </div>
        <div id="teste-el" />
      </Servicos>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <img src={ImgInsideModal} alt="AMZ" />
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Home;
